export default __webpack_public_path__ + "static/media/performance.6e78ac2f.png";